import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoCloseOutline } from "react-icons/io5";
import "./DialogBoxCon.css";

const noImageFound =
  "https://storage.googleapis.com/public-images-plutosone/cbms/campaign/image-1748116463913-oh-no-comic-word-bubble-pop-art-retro-style-oh-no-phrase-failure-bad-news-mistakes-concept-oh-no-comic-word-bubble-pop-203076041.webp";

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
};

const modalVariants = {
  hidden: { opacity: 0, scale: 0.9, y: "-50%", x: "-50%" },
  visible: {
    opacity: 1,
    scale: 1,
    y: "-50%",
    x: "-50%",
    transition: { duration: 0.3, ease: "easeOut" },
  },
  exit: { opacity: 0, scale: 0.95, transition: { duration: 0.2 } },
};

const DialBoxContent = ({
  open,
  handleClose,
  title,
  heading,
  subHeading,
  images,
  data,
}) => {
  const resolvedHeading = heading || title?.toUpperCase();

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="dialogboxcon-backdrop"
          variants={backdropVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
        >
          <motion.div
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="dialogboxcon-modal"
            style={{ transform: "translate(-50%, -50%)" }}
          >
            <div className="dialogboxcon-shell">
              <div className="dialogboxcon-toolbar">
                <div className="dialogboxcon-title-wrap">
                  <h2 className="dialogboxcon-title">{resolvedHeading}</h2>
                  {subHeading && (
                    <p className="dialogboxcon-subtitle">{subHeading}</p>
                  )}
                </div>
                <button
                  onClick={handleClose}
                  className="dialogboxcon-close-btn"
                  aria-label="Close dialog"
                >
                  <IoCloseOutline size={22} />
                </button>
              </div>

              <div className="dialogboxcon-content">
                {images && Object.entries(images).length > 0 && (
                  <div
                    className="dialogboxcon-image-grid"
                    style={{
                      gridTemplateColumns: `repeat(${Object.entries(images).length}, minmax(0, 1fr))`,
                    }}
                  >
                    {Object.entries(images).map(([key, src], index) => (
                      <div key={index} className="dialogboxcon-image-card">
                        <img
                          src={src}
                          alt={key}
                          loading="lazy"
                          className="dialogboxcon-image"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = noImageFound;
                          }}
                        />
                        <div className="dialogboxcon-image-label">
                          {key}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="dialogboxcon-data-grid">
                  {Object.entries(data).map(([label, value], index) => (
                    <div key={index} className="dialogboxcon-data-item">
                      <span className="dialogboxcon-data-label">
                        {label}
                      </span>
                      <div className="dialogboxcon-data-value">
                        {value}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DialBoxContent;
